import { connect } from 'react-redux'
import PresenterModalManager from './PresenterModalManager'
import { withRouter } from 'react-router-dom'
import selectShowGoingLiveModal from '../../dataStore/selectors/selectShowGoingLiveModal'
import { State } from '../../dataStore/reducers/reducerType'
import { PresenterModalManagerManualProps } from './types'

const mapStateToProps = (state: State): PresenterModalManagerManualProps => ({
  status: state.ui.status,
  isDeadMansHandleOpen: state.ui.isDeadMansHandleOpen,
  showLiveEnabledModal: state.ui.showLiveEnabledModal,
  showGoingLiveModal: selectShowGoingLiveModal(state),
  showSettingsModal: state.ui.showSettingsModal,
  showRescheduledModal: state.ui.showRescheduledModal,
  showReconnectingModal: state.ui.twilioConnectionError !== null,
  showPlayInModal: state.ui.showPlayInModal,
  showSlidesUploadModal: state.ui.showSlidesUploadModal,
  showSlidesRemoveConfirmModal: state.slides.showSlidesRemoveConfirmModal,
  showGigStartConfirmationModal: state.ui.showGigStartConfirmationModal,
  showGigEndConfirmationModal: state.ui.showGigEndConfirmationModal,
  showStreamModal: state.ui.showStreamModal
})

export default withRouter(connect(mapStateToProps)(PresenterModalManager))
